// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-overlay-spinner {\n  top: 0%;\n  z-index: 10;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.5;\n  position: absolute;\n}\n\n.loader {\n  animation: spin 1000ms linear infinite;\n}\n", ""]);
// Exports
module.exports = exports;
